import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';
import * as firebase from 'firebase/app';

@Injectable()
export class UserProvider {

  consultaUsers = this.afstore.collection('users').ref;
  consultaStorage = firebase.storage().ref();
  pastaImagens
  
  constructor(
    public afireauth: AngularFireAuth,
    public afstore: AngularFirestore
  ) {
  }

  getuserdetails() {
    return new Promise((resolve, reject) => {
      this.afireauth.authState.subscribe(user => {
        this.consultaUsers.doc(user.uid).onSnapshot((doc) => {
          resolve(doc.data());
        })
      })
    });
  }

  adicionarDocumentoUser(idUsuario, documento, tarefa) {
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idUsuario).collection('doc').add({
        nomeDoc : documento,
        urlDOC : tarefa,
        data : new Date()
      }).then(() => {
        resolve({ success: true });
        }).catch((err) => {
        reject(err);
      })
    })
  }

  //Consulta de usuário limitado
  adicionarDocumentoUserComum(idUsuario, documento, tarefa){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idUsuario).collection('meusDocs').add({
        nomeDoc : documento,
        urlDOC : tarefa,
        data : new Date()
      }).then(() => {
        resolve({ success: true });
        }).catch((err) => {
        reject(err);
      })
    })
  }
  
  adicionarBoletoUser(idUsuario, boleto, tarefaBoleto){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idUsuario).collection('boletos').add({
        nomeBoleto : boleto,
        urlDOC : tarefaBoleto,
        data : new Date()
      }).then(() => {
        resolve({ success: true });
        }).catch((err) => {
        reject(err);
      })
    })
  }

  adicionarPastaUser(idUsuario, nomePasta){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idUsuario).collection('pasta').add({
        nomePasta : nomePasta,
        data : new Date()
      }).then(() => {
        resolve({ success: true });
        }).catch((err) => {
        reject(err);
      })
    })
  }

  adicionarPastaBoletosUser(idUsuario, nomePasta){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idUsuario).collection('pastaBoletos').add({
        nomePasta : nomePasta,
        data : new Date()
      }).then(() => {
        resolve({ success: true });
        }).catch((err) => {
        reject(err);
      })
    })
  }

  //Consulta de usuário limitado
  consultarDoc(){
      return new Promise((resolve, reject) => {
        this.afireauth.authState.subscribe(user => {
          this.consultaUsers.doc(user.uid).collection('doc').orderBy('nomeDoc').get()
            .then((querySnapshot) => {
              let obj: any = [];

              querySnapshot
                .forEach((doc: any) => {
                  obj.push({
                    id: doc.id,
                    nomeDoc: doc.data().nomeDoc,
                    urlDOC: doc.data().urlDOC,
                    data: doc.data().data.getDate() + "/" + (doc.data().data.getMonth() + 1) + '/' + doc.data().data.getFullYear()
                  });
                });
              resolve(obj);
            })
            .catch((error: any) => {
              reject(error);
            });
        });
      });
    }

    //Consulta de usuário limitado
    consultarBoleto(){
      return new Promise((resolve, reject) => {
        this.afireauth.authState.subscribe(user => {
          this.consultaUsers.doc(user.uid).collection('boletos').orderBy('nomeBoleto').get()
            .then((querySnapshot) => {
              let obj: any = [];

              querySnapshot
                .forEach((doc: any) => {
                  obj.push({
                    id: doc.id,
                    nomeBoleto: doc.data().nomeBoleto,
                    urlDOC: doc.data().urlDOC,
                    data: doc.data().data.getDate() + "/" + (doc.data().data.getMonth() + 1) + '/' + doc.data().data.getFullYear()
                  });
                });
              resolve(obj);
            })
            .catch((error: any) => {
              reject(error);
            });
        });
      });
    }
    
    //Consulta de usuário limitado
    consultarDocUserComum(){
      return new Promise((resolve, reject) => {
        this.afireauth.authState.subscribe(user => {
          this.consultaUsers.doc(user.uid).collection('meusDocs').orderBy('nomeDoc').get()
            .then((querySnapshot) => {
              let obj: any = [];

              querySnapshot
                .forEach((doc: any) => {
                  obj.push({
                    id: doc.id,
                    nomeDoc: doc.data().nomeDoc,
                    urlDOC: doc.data().urlDOC,
                    data: doc.data().data.getDate() + "/" + (doc.data().data.getMonth() + 1) + '/' + doc.data().data.getFullYear()
                  });
                });
              resolve(obj);
            })
            .catch((error: any) => {
              reject(error);
            });
        });
      });
    }

    //Consulta de usuário limitado
    consultaPastasUsuarioComum() {
      return new Promise((resolve, reject) => {
        this.afireauth.authState.subscribe(user => {
          this.consultaUsers.doc(user.uid).collection('pasta').orderBy('nomePasta').get()
          .then((querySnapshot) => {
            let obj: any = [];

            querySnapshot
              .forEach((doc: any) => {
                obj.push({
                  id: doc.id,
                  nomePasta: doc.data().nomePasta,
                  data: doc.data().data.getDate() + "/" + (doc.data().data.getMonth() + 1) + '/' + doc.data().data.getFullYear()
                });
              });
            resolve(obj);
          })
          .catch((error: any) => {
            reject(error);
          });
      });
    });
  }

  //consulta de usuário limitado
  consultaPastasBoletoUsuarioComum(){
    return new Promise((resolve, reject) => {
      this.afireauth.authState.subscribe(user => {
        this.consultaUsers.doc(user.uid).collection('pastaBoletos').orderBy('nomePasta').get()
        .then((querySnapshot) => {
          let obj: any = [];

          querySnapshot
            .forEach((doc: any) => {
              obj.push({
                id: doc.id,
                nomePasta: doc.data().nomePasta,
                data: doc.data().data.getDate() + "/" + (doc.data().data.getMonth() + 1) + '/' + doc.data().data.getFullYear()
              });
            });
          resolve(obj);
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    });
  }

  //Consulta usuário limitado
  consultaNomePastaUsuarioSelecionada(idPastaSelecionada){
    return new Promise((resolve, reject) => {
      this.afireauth.authState.subscribe(user => {
        this.consultaUsers.doc(user.uid).collection('pasta').doc(idPastaSelecionada).onSnapshot((doc) => {
          resolve(doc.data());
        })
      })
    });
  }
  
  consultaNomePastaUsuarioBoletoSelecionada(idPastaSelecionada){
    return new Promise((resolve, reject) => {
      this.afireauth.authState.subscribe(user => {
        this.consultaUsers.doc(user.uid).collection('pastaBoletos').doc(idPastaSelecionada).onSnapshot((doc) => {
          resolve(doc.data());
        })
      })
    });
  }

  //Consulta usuário limitado
  consultaDocsUsuarioPastaSelecionada(idPastaSelecionada){
    return new Promise((resolve, reject) => {
      this.afireauth.authState.subscribe(user => {
        this.consultaUsers.doc(user.uid).collection('pasta').doc(idPastaSelecionada).collection('doc').orderBy('nomeDoc').get()
          .then((querySnapshot) => {
            let obj: any = [];

            querySnapshot
              .forEach((doc: any) => {
                obj.push({
                  id: doc.id,
                  nomeDoc: doc.data().nomeDoc,
                  urlDOC: doc.data().urlDOC,
                  data: doc.data().data.getDate() + "/" + (doc.data().data.getMonth() + 1) + '/' + doc.data().data.getFullYear()
                });
              });
            resolve(obj);
          })
          .catch((error: any) => {
            reject(error);
          });
        })
      });
  }

  consultaBoletosUsuarioPastaSelecionada(idPastaSelecionada){
    return new Promise((resolve, reject) => {
      this.afireauth.authState.subscribe(user => {
        this.consultaUsers.doc(user.uid).collection('pastaBoletos').doc(idPastaSelecionada).collection('boletos').orderBy('nomeBoleto').get()
          .then((querySnapshot) => {
            let obj: any = [];

            querySnapshot
              .forEach((doc: any) => {
                obj.push({
                  id: doc.id,
                  nomeBoleto: doc.data().nomeBoleto,
                  urlDOC: doc.data().urlDOC,
                  data: doc.data().data.getDate() + "/" + (doc.data().data.getMonth() + 1) + '/' + doc.data().data.getFullYear()
                });
              });
            resolve(obj);
          })
          .catch((error: any) => {
            reject(error);
          });
        })
      });
  }

  consultaUsuariosCadastrados(){
    return new Promise((resolve, reject) => {
      this.consultaUsers.orderBy('displayName').get()
        .then((querySnapshot) => {
          let obj: any = [];

          querySnapshot
            .forEach((doc: any) => {
              obj.push({
                id: doc.id,
                displayName: doc.data().displayName
              });
            });
          resolve(obj);
        })
        .catch((error: any) => {
          reject(error);
        });
    });  
  }

  consultarDocUser(idUsuario){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idUsuario).collection('doc').orderBy('nomeDoc').get()
        .then((querySnapshot) => {
          let obj: any = [];

          querySnapshot
            .forEach((doc: any) => {
              obj.push({
                id: doc.id,
                nomeDoc: doc.data().nomeDoc,
                urlDOC: doc.data().urlDOC,
                data: doc.data().data.getDate() + "/" + (doc.data().data.getMonth() + 1) + '/' + doc.data().data.getFullYear()
              });
            });
          resolve(obj);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  consultarBoletoUser(idUsuario){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idUsuario).collection('boletos').orderBy('nomeBoleto').get()
        .then((querySnapshot) => {
          let obj: any = [];

          querySnapshot
            .forEach((doc: any) => {
              obj.push({
                id: doc.id,
                nomeBoleto: doc.data().nomeBoleto,
                urlDOC: doc.data().urlDOC,
                data: doc.data().data.getDate() + "/" + (doc.data().data.getMonth() + 1) + '/' + doc.data().data.getFullYear()
              });
            });
          resolve(obj);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  consultaDocsEnviadoUser(idUsuario){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idUsuario).collection('meusDocs').orderBy('nomeDoc').get()
        .then((querySnapshot) => {
          let obj: any = [];

          querySnapshot
            .forEach((doc: any) => {
              obj.push({
                id: doc.id,
                nomeDoc: doc.data().nomeDoc,
                urlDOC: doc.data().urlDOC,
                data: doc.data().data.getDate() + "/" + (doc.data().data.getMonth() + 1) + '/' + doc.data().data.getFullYear()
              });
            });
          resolve(obj);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  consultaPastaUser(idUsuario){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idUsuario).collection('pasta').orderBy('nomePasta').get()
        .then((querySnapshot) => {
          let obj: any = [];

          querySnapshot
            .forEach((doc: any) => {
              obj.push({
                id: doc.id,
                nomePasta: doc.data().nomePasta,
                data: doc.data().data.getDate() + "/" + (doc.data().data.getMonth() + 1) + '/' + doc.data().data.getFullYear()
              });
            });
          resolve(obj);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  consultaPastaBoletosUser(idUsuario){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idUsuario).collection('pastaBoletos').orderBy('nomePasta').get()
        .then((querySnapshot) => {
          let obj: any = [];

          querySnapshot
            .forEach((doc: any) => {
              obj.push({
                id: doc.id,
                nomePasta: doc.data().nomePasta,
                data: doc.data().data.getDate() + "/" + (doc.data().data.getMonth() + 1) + '/' + doc.data().data.getFullYear()
              });
            });
          resolve(obj);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  consultaNomePastaSelecionada(idPastaSelecionada, idUsuario){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idUsuario).collection('pasta').doc(idPastaSelecionada).onSnapshot((doc) => {
        resolve(doc.data());
      })
    });
  }

  consultaNomePastaBoletoSelecionada(idPastaSelecionada, idUsuario){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idUsuario).collection('pastaBoletos').doc(idPastaSelecionada).onSnapshot((doc) => {
        resolve(doc.data());
      })
    });
  }

  consultaDocsPastaBoletoSelecionada(idPastaSelecionada, idUsuario){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idUsuario).collection('pastaBoletos').doc(idPastaSelecionada).collection('boletos').orderBy('nomeBoleto').get()
        .then((querySnapshot) => {
          let obj: any = [];

          querySnapshot
            .forEach((doc: any) => {
              obj.push({
                id: doc.id,
                nomeBoleto: doc.data().nomeBoleto,
                urlDOC: doc.data().urlDOC,
                data: doc.data().data.getDate() + "/" + (doc.data().data.getMonth() + 1) + '/' + doc.data().data.getFullYear()
              });
            });
          resolve(obj);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  consultaDocsPastaSelecionada(idPastaSelecionada, idUsuario){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idUsuario).collection('pasta').doc(idPastaSelecionada).collection('doc').orderBy('nomeDoc').get()
        .then((querySnapshot) => {
          let obj: any = [];

          querySnapshot
            .forEach((doc: any) => {
              obj.push({
                id: doc.id,
                nomeDoc: doc.data().nomeDoc,
                urlDOC: doc.data().urlDOC,
                data: doc.data().data.getDate() + "/" + (doc.data().data.getMonth() + 1) + '/' + doc.data().data.getFullYear()
              });
            });
          resolve(obj);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  consultaUsuarios(){
    return new Promise((resolve, reject) => {
      this.consultaUsers.orderBy('displayName').get()
        .then((querySnapshot) => {
          let obj: any = [];

          querySnapshot
            .forEach((doc: any) => {
              obj.push({
                id: doc.id,
                displayName: doc.data().displayName,
                uid: doc.data().uid
              });
            });
          resolve(obj);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  arquivarDocUser(idDialogUser, idPastaArquivo, idDialogDocUser){
      return new Promise((resolve, reject) => {
        this.consultaUsers.doc(idDialogUser).collection('doc').doc(idDialogDocUser).get()
        .then((querySnapshot) => {
          this.consultaUsers.doc(idDialogUser).collection('pasta').doc(idPastaArquivo).collection('doc').add({
            id: idDialogDocUser,
            nomeDoc: querySnapshot.data().nomeDoc,
            urlDOC: querySnapshot.data().urlDOC,
            data : new Date()
          }).then(() => {
              this.consultaUsers.doc(idDialogUser).collection('doc').doc(idDialogDocUser).delete()
              .then(() =>{
                resolve({ success: true });
              }).catch((error: any) => {
                reject(error);
              });
            }).catch((err) => {
            reject(err);
          })
        })
        .catch((error: any) => {
          reject(error);
        });
      });
  }

  arquivarBoletoUser(idDialogUser, idPastaArquivo, idDialogBoletoUser){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idDialogUser).collection('boletos').doc(idDialogBoletoUser).get()
      .then((querySnapshot) => {
        this.consultaUsers.doc(idDialogUser).collection('pastaBoletos').doc(idPastaArquivo).collection('boletos').add({
          id: idDialogBoletoUser,
          nomeBoleto: querySnapshot.data().nomeBoleto,
          urlDOC: querySnapshot.data().urlDOC,
          data : new Date()
        }).then(() => {
            this.consultaUsers.doc(idDialogUser).collection('boletos').doc(idDialogBoletoUser).delete()
            .then(() =>{
              resolve({ success: true });
            }).catch((error: any) => {
              reject(error);
            });
          }).catch((err) => {
          reject(err);
        })
      })
      .catch((error: any) => {
        reject(error);
      });
    });
  }

  deletarDocUser(valorIdDocumento, valorIdUsuario){
    return new Promise((resolve, reject) => {
        this.consultaUsers.doc(valorIdUsuario).collection('doc').doc(valorIdDocumento).delete()
          .then(() => {
            resolve();
          }).catch((error: any) => {
            reject(error);
          });
    });
  }

  deletarBoletoUser(valorIdBoleto, valorIdUsuario){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(valorIdUsuario).collection('boletos').doc(valorIdBoleto).delete()
        .then(() => {
          resolve();
        }).catch((error: any) => {
          reject(error);
        });
    });
  }

  deletarDocPastaUser(idUsuario, idPasta, idDocumento){
    return new Promise((resolve, reject) => {
        this.consultaUsers.doc(idUsuario).collection('pasta').doc(idPasta).collection('doc').doc(idDocumento).delete()
          .then(() => {
            resolve();
          }).catch((error: any) => {
            reject(error);
          });
    });
  }

  deletarBoletoPastaUser(idUsuario, idPasta, idBoleto){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idUsuario).collection('pastaBoletos').doc(idPasta).collection('boletos').doc(idBoleto).delete()
        .then(() => {
          resolve();
        }).catch((error: any) => {
          reject(error);
        });
    });
  }

  consultaDadosUsuarioCadastrado(idUsuario) {
    return new Promise((resolve, reject) => {
        this.consultaUsers.doc(idUsuario).onSnapshot((doc) => {
          resolve(doc.data());
        })
    });
  }

  //revisar delete pois não está deletando no storage e authentication
  deletarUsuario(idUsuario){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idUsuario).delete()
        .then(() => {
          resolve();
        }).catch((error: any) => {
          reject(error);
        });
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/user.service.ts